<h2>{{ 'ACCOUNTS_MODULE.compOblHistTable.title' | translate }}</h2>
<div class="table-area">
  <app-table-view
    [config]="compensationObligationTableConfig"
    [data]="data">
  </app-table-view>
</div>
